import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from 'components/Common/MUICustomAutocomplete';

interface IDebarredOpts {
  formValues: any;
  setFormValues: any;
  setCountryOpts: any;
  selectedIndex: string;
  countryOpts: any;
  countryData: any;
  listNameOpts: any;
  setListNameOpts: any;
  stateOpts: any;
  setStateOpts: any;
  biteListPrimaryOpts: any;
  toClear: boolean;
}

const DebarredOptions: React.FC<IDebarredOpts> = ({
  biteListPrimaryOpts,
  selectedIndex,
  formValues,
  setFormValues,
  countryOpts,
  setCountryOpts,
  listNameOpts,
  setListNameOpts,
  stateOpts,
  setStateOpts,
  toClear,
}) => {
  const handleAgencySelect = async(e: any) => {
    const obj = {
      ...formValues,
      govtAgency: e,
      listName: [],
      country: [],
      state: [],
    };
    setFormValues(obj);
    if (obj && obj.govtAgency.length !== 0) {
      setListNameOpts({ isLoading: true, data: {} });
      setCountryOpts({ isLoading: true, data: {} });
      setStateOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        govtAgency: obj.govtAgency,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.listNameAgg.buckets);
          },
        );
      }
      setListNameOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleListNameSelect = async(e: any) => {
    const obj = {
      ...formValues,
      listName: e,
      country: [],
      state: [],
    };
    setFormValues(obj);
    if (obj && obj.listName.length !== 0) {
      setCountryOpts({ isLoading: true, data: {} });
      setStateOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        listName: obj.listName,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.listNameAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.countryAgg.buckets);
            });
          },
        );
      }
      setCountryOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleCountrySelect = async(e: any) => {
    const obj = {
      ...formValues,
      country: e,
      state: [],
    };
    setFormValues(obj);
    if (obj && obj.country.length !== 0) {
      setStateOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        listCountry: obj.country,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.listNameAgg.buckets.map((secondBucket: any) => {
              secondBucket.countryAgg.buckets.map((thirdBucket: any) => {
                addedBuckets.push(thirdBucket.stateAgg.buckets);
              });
            });
          },
        );
      }
      setStateOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleStateSelect = async(e: any) => {
    setFormValues({ ...formValues, state: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!biteListPrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={biteListPrimaryOpts.data.countryAgg.buckets}
          placeholder='Agency'
          onChange={handleAgencySelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!listNameOpts.isLoading ? listNameOpts.data : []}
        placeholder='List Name'
        onChange={handleListNameSelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!countryOpts.isLoading ? countryOpts.data : []}
        placeholder='Country'
        onChange={handleCountrySelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!stateOpts.isLoading ? stateOpts.data : []}
        placeholder='State'
        onChange={handleStateSelect}
        toClear={toClear}
      />
    </div>
  );
};

export default DebarredOptions;
